<div class="dialog-header">
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog()"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <div class="image-wrapper" *ngIf="imageBannerPath">
    <img
      class="banner"
      [src]="imageBannerPath"
      [attr.alt]="'platform-news.banner-alt' | translate"
    />
  </div>
  <h2>{{ "platform-news.title" | translate }}</h2>
  <div class="image-wrapper" *ngIf="image2Path">
    <img
      class="logo"
      [src]="image2Path"
      [attr.alt]="'platform-news.logo-alt' | translate"
    />
  </div>
  <p class="message" [innerHTML]="'platform-news.message' | translate"></p>
</div>

<div class="dialog-actions">
  <button mat-raised-button color="primary" (click)="closeDialog()">
    {{ "input-confirm" | translate }}
  </button>
</div>
